import { Button, CssBaseline, makeStyles, Typography, List, ListItem, Box } from '@material-ui/core';
import { COLORS } from '../../shared/Theme';

import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import axios from 'axios';
import { admin as v_admin, basic, Values } from '../../request/values';
import { useCookies } from 'react-cookie';
import { SubAdminHeaderBar } from '../../shared/header/HeaderBar';

//const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	content: {
		width: '100%',
		height: '100%',
		display: 'grid',
		//gridTemplateColumns: '230px 1fr',
	},
	mainPage: {
		display: 'flex',
		flexDirection: 'column',
		gap: '5vh',
	},
	userinfo: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		border: 'none',
		borderWidth: '0px 0px 1px 0px',
		paddingBottom: '0.5vh',
		'& #name': {
			display: 'inline-block',
			fontFamily: 'NanumR',
			fontSize: '1.25rem',
			fontWeight: 'bolder',
		},
	},
	form: {
		display: 'flex',
		width: '97%',
		height: '5%',
		justifyContent: 'right',
		alignItems: 'center',
		gap: '1%',
		'& input': {
			width: '15%',
			height: '80%',
			paddingLeft: '7px',
		},
		'& Button': {
			//border: 'solid 1px',
			border: 'solid gray 1px',
			height: '90%',
			//borderStyle: 'inset',
			//backgroundColor: '-webkit-control-background',
		},
	},
	submit: {},
	classList: {
		'& #classOpen': {
			float: 'right',
			margin: '5px 3%',
			padding: '5px 25px',
			color: `${COLORS.WHITE}`,
			borderRadius: '5px',
			backgroundColor: `${COLORS.WATER_BLUE}`,
			'&:hover': {
				color: `${COLORS.WATER_BLUE}`,
				backgroundColor: 'inherit',
			},
		},
		'& #logout': {
			float: 'left',
			margin: '5px 3%',
			padding: '5px 25px',
			color: `${COLORS.WHITE}`,
			borderRadius: '5px',
			backgroundColor: `${COLORS.WATER_BLUE}`,
			'&:hover': {
				color: `${COLORS.WATER_BLUE}`,
				backgroundColor: 'inherit',
			},
		},
	},
	table: {
		display: 'grid',
		gridTemplateRows: '50px 1fr',
		width: '94%',
		height: '60vh',
		margin: '1% 3%',
		borderBottom: '2px solid black',
		//border: 'none',
		//borderRadius: '10px 10px 0 10px',
		'& #title': {
			display: 'grid',
			gridTemplateColumns: '3fr 4fr 2fr 1fr 4fr 17px',
			border: 'solid',
			borderWidth: '0 0 2px 0',
			//background: 'none',
			'& span': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				'& p': {
					fontSize: '1.15rem',
					fontWeight: 'bolder',
				},
			},
		},
		'& #classinfo': {
			overflow: 'scroll',
			overflowX: 'hidden',
			borderRadius: '0 0 0 10px',
		},
		'& ul': {
			padding: '0',
		},
		'& li': {
			border: 'solid gray',
			borderWidth: '0 0 1px 0',
		},
	},
	classInfo: {
		display: 'grid',
		gridTemplateColumns: '3fr 4fr 2fr 1fr 4fr 17px',
		padding: '25px 0',
		//backgroundColor: `${COLORS.LIGHT_GREY}`,
		backgroundColor: `${COLORS.WHITE}`,
	},
	buttonLabel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: 'none',
		fontSize: '1rem',
		fontFamily: 'NanumB',
		//fontWeight: 'bold',
		lineHeight: '21px',
		bolderWidth: '1px',
	},
	blank: {
		display: 'flex',
		height: '40px',
	},
}));

type iClassList = {
	class_code: string;
	class_name: string;
	class_country: string;
	start_date: string;
	class_version: string;
	reg_date: string;
	language: string;
};

const SERVER = basic.server;

const SubAdminClassList: React.FC<any> = (props) => {
	const classes = useStyles();
	let history = useHistory();

	const { member, deleteMember } = props;
	const [cookies, setCookie, removeCookie] = useCookies();

	const [ClassList, setClassList] = useState<iClassList[]>([]);
	const [targetClassName, setTargetClassName] = useState<any | null>();

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { id, value } = e.target;
		if (id == 'targetClassName') setTargetClassName(value);
	};

	const searchControl = () => {
		if (targetClassName == '') getClassContent();
		else searchClassContent();
	};

	const searchClassContent = () => {
		let url = new URL(SERVER + v_admin.admin + v_admin.search_class);
		let params = {
			id: member.id.toString(),
			targetClassName: targetClassName.toString(),
		};
		url.search = new URLSearchParams(params).toString();
		axios({
			method: 'GET',
			withCredentials: true,
			//url: SERVER + v_admin.admin + v_admin.search_class,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setClassList(data.data);
				}
				if (data.code == Values.FAIL_CODE) {
					setClassList([]);
				}
			});
	};

	const getClassContent = () => {
		let url = new URL(SERVER + v_admin.admin + v_admin.class_list);
		let params = { id: member.id.toString() };
		url.search = new URLSearchParams(params).toString();
		axios({
			method: 'GET',
			withCredentials: true,
			//url: SERVER + v_admin.admin + v_admin.class_list,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setClassList(data.data);
				}
			});
	};

	const moveCreateClass = () => {
		history.push('/subAdminCreateClass');
	};
	const logout = () => {
		removeCookie('access');
		deleteMember();
		history.push('/admin');
	};

	useEffect(() => {
		getClassContent();
	}, []);

	return (
		<div className={classes.background}>
			<CssBaseline />
			<div className={classes.content}>
				<div className={classes.mainPage}>
					<SubAdminHeaderBar />
					<div className={classes.classList}>
						<div className={classes.form}>
							<input
								type="text"
								placeholder="검색할 교육명을 입력해주세요."
								id="targetClassName"
								onChange={valueChangeHandler}
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										searchControl();
									}
								}}
							/>
							<Button onClick={searchControl}>
								<Typography>검색</Typography>
							</Button>
						</div>
						<div className={classes.table}>
							<div id="title">
								{/* <span>
                                    <Typography>교육 날짜</Typography>
                                </span> */}
								<span>
									<Typography>클래스 코드</Typography>
								</span>
								<span>
									<Typography>교육명</Typography>
								</span>
								<span>
									<Typography>버전</Typography>
								</span>
								<span>
									<Typography>언어</Typography>
								</span>
								<span>
									<Typography>등록일자</Typography>
								</span>
							</div>
							<List id="classinfo">
								{ClassList != null &&
									ClassList.map((item: any, index: number) => {
										return (
											<AppListItem
												index={index}
												code={item.class_code}
												name={item.class_name}
												version={item.class_version}
												language={item.language}
												//place={item.class_country}
												startDate={item.start_date}
												date={item.reg_date}
											/>
										);
									})}
								<div className={classes.blank}></div>
							</List>
						</div>
						<Button id="classOpen" onClick={(e) => moveCreateClass()}>
							<Typography>클래스 개설</Typography>
						</Button>
						<Button id="logout" onClick={logout}>
							<Typography>로그아웃</Typography>
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

const AppListItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { index, code, name, version, language, startDate, date } = props;

	return (
		<ListItem id={index} className={classes.classInfo}>
			{/* <Box className={classes.buttonLabel}>{startDate}</Box> */}
			<Box className={classes.buttonLabel}>{code}</Box>
			<Box className={classes.buttonLabel}>{name}</Box>
			<Box className={classes.buttonLabel}>{version}</Box>
			<Box className={classes.buttonLabel}>{language}</Box>
			<Box className={classes.buttonLabel}>{date.toString().slice(0, 10)}</Box>
		</ListItem>
	);
};

export default SubAdminClassList;
